<div class="sticky-top">
  <div
    class="d-flex align-items-center justify-content-between navbar-primary pl-md-3 pr-md-2"
  >
    <div>
      <a routerLink="dashboard" aria-label="Dashboard">
        <img src="assets/logo/ingo-logo.svg" alt="" width="48" height="48" />
      </a>
    </div>
  </div>

  <div class="content-container wrapper">
    <div>
      <h2 class="main-heading text-uppercase text-center mb-5">
        {{ "addMasterCard.title" | translate }}
      </h2>
      <p class="text-size-m">{{ "masterCardLanding.info.1" | translate }}</p>
      <p class="font-weight-bold">
        {{ "masterCardLanding.info.2" | translate }}
      </p>

      <h6 class="font-weight-bold">
        {{ "masterCardLanding.step1.name" | translate }}
      </h6>
      <p>
        {{ "masterCardLanding.step1.description1" | translate
        }}<a [routerLink]="redirectUrl">{{
          "masterCardLanding.here" | translate
        }}</a
        >{{ "masterCardLanding.step1.description2" | translate }}
      </p>
      <h6 class="font-weight-bold">
        {{ "masterCardLanding.step2.name" | translate }}
      </h6>
      <p>
        {{ "masterCardLanding.step2.description" | translate }}
      </p>
    </div>

    <div class="text-center mt-4">
      <button
        type="submit"
        class="btn btn-primary btn-block btn-lg"
        [routerLink]="redirectUrl"
        [disabled]="processing"
      >
        {{ "addMasterCard.applyBtn" | translate }}
      </button>
    </div>
  </div>
</div>
